import { mutatorAction } from 'satcheljs';
import getCalendarPickerStore from '../selectors/getCalendarPickerStore';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';
import type { CalendarPickerItemDragData } from '../store/schema/CalendarPickerItemDragData';

export const setDraggedItemData = mutatorAction(
    'setDraggedItemData',
    (scenarioId: CalendarPickerScenarioId, dragItemData: CalendarPickerItemDragData | null) => {
        const store = getCalendarPickerStore(scenarioId);
        store.draggedItemData = dragItemData;
    }
);
